import React, { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { LoadingSpinner } from '../common/LoadingSpinner';
import { Brand } from '../common/Brand';

// The second step of a 2FA login: the user has passed password/OAuth and now
// enters a code from their authenticator app (or a recovery code). On success
// completeLogin2fa stores the JWT and sets the user; onDone navigates onward.
export const TwoFactorChallenge: React.FC<{
  mfaToken: string;
  onDone: () => void;
  onCancel?: () => void;
}> = ({ mfaToken, onDone, onCancel }) => {
  const { completeLogin2fa } = useAuth();
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await completeLogin2fa(mfaToken, code.trim());
      onDone();
    } catch (err: any) {
      setError(err.response?.data?.detail || 'That code was not accepted. Please try again.');
      setCode('');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth auth-center">
      <div className="auth-card">
        <div className="auth-brand"><Brand variant="full" height={64} /></div>
        <h1 className="auth-title">Two-factor authentication</h1>
        <p className="auth-sub">Enter the 6-digit code from your authenticator app.</p>
        <form onSubmit={submit}>
          {error && <div className="auth-error">{error}</div>}
          <div className="auth-field">
            <label className="auth-label" htmlFor="mfa-code">Authentication code</label>
            <input
              id="mfa-code" name="mfa-code" type="text" inputMode="numeric" autoComplete="one-time-code"
              autoFocus required className="auth-input" placeholder="123456"
              value={code} onChange={(e) => setCode(e.target.value)}
            />
          </div>
          <button type="submit" disabled={loading || !code.trim()} className="auth-btn" style={{ marginTop: 6 }}>
            {loading ? <LoadingSpinner size="sm" /> : 'Verify'}
          </button>
        </form>
        <p className="auth-note" style={{ textAlign: 'center', marginTop: 14 }}>
          Lost your authenticator? Enter one of your recovery codes above.
        </p>
        {onCancel && (
          <p className="auth-sub" style={{ textAlign: 'center', marginTop: 10 }}>
            <button type="button" className="linklike" onClick={onCancel}>Back to sign in</button>
          </p>
        )}
      </div>
    </div>
  );
};
